"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CreateBucketInput_1 = require("./CreateBucketInput");
var CreateBucketOutput_1 = require("./CreateBucketOutput");
var BucketAlreadyExists_1 = require("./BucketAlreadyExists");
var BucketAlreadyOwnedByYou_1 = require("./BucketAlreadyOwnedByYou");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.CreateBucket = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "CreateBucket",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}"
    },
    input: {
        shape: CreateBucketInput_1.CreateBucketInput
    },
    output: {
        shape: CreateBucketOutput_1.CreateBucketOutput
    },
    errors: [
        {
            shape: BucketAlreadyExists_1.BucketAlreadyExists
        },
        {
            shape: BucketAlreadyOwnedByYou_1.BucketAlreadyOwnedByYou
        }
    ]
};
//# sourceMappingURL=CreateBucket.js.map